import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../components/card/card";
import React, { useEffect, useContext, useState } from "react";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { document } from "../../api";

function ReportDocument() {
  const [openDlg, setOpenDlg] = useState(false);
  const [listData, setListData] = useState([]);
  function closeDialog() {
    setOpenDlg(false);
  }
  async function getData() {
    const res = await document.list();
    if (res.ok) {
      const body = await res.json();
      const data = body.data;
      setListData(data);
    }
  }
  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      <ConfirmationDlg
        open={openDlg}
        onClose={closeDialog}
        btnSubmitText={"Submit"}
        btnCancelText={"Cancel"}
      >
        <div className="form-group mb-3">
          <label>Title</label>
          <input type="text" className={"form-control"} />
        </div>
        <div className="form-group mb-3">
          <label>Description</label>
          <textarea className={"form-control"}> </textarea>
        </div>
        <div className="form-group">
          <label>File</label>
          <input type="file" className={"form-control"} />
        </div>
      </ConfirmationDlg>
      <div className="row justify-content-center">
        <div className="col-sm-12 col-lg-10 col-md-10">
          <Card>
            <CardHeader className="d-flex justify-content-between">
              <h4>Documents</h4>
              {/*<div*/}
              {/*  style={{ width: "200px" }}*/}
              {/*  className="ms-auto btn-group"*/}
              {/*  onClick={() => setOpenDlg(true)}*/}
              {/*>*/}
              {/*  <a href="#/" className="btn btn-outline-theme btn-sm">*/}
              {/*    <i className="fa fa-upload"></i> Upload Docs*/}
              {/*  </a>*/}
              {/*</div>*/}
            </CardHeader>
            <CardBody>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {listData.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item.title}</td>
                      <td>{item.description}</td>
                      <td>
                        <a
                          href={item.url}
                          className={"btn btn-sm btn-outline-theme"}
                          target={"_blank"}
                          style={{
                            textAlign: "center",
                            textDecoration: "none",
                          }}
                        >
                          <i
                            className="fa fa-file-pdf"
                            style={{ fontSize: "15px" }}
                          ></i>{" "}
                          View Document
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default ReportDocument;
